/*
  Motion for the grange-* homepage sections: rows that rise into view as
  you scroll ([data-ge-reveal]) and the hero's rotating photos. Content is
  only ever hidden after this script has run, and nothing moves for visitors
  who prefer reduced motion. Each section includes this file, so it guards
  against running twice.
*/
(function () {
  if (window.geMotion) return;
  window.geMotion = true;

  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    if (calm || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var groups = document.querySelectorAll('[data-ge-reveal]');
    if (!groups.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    groups.forEach(function (group) {
      // Rows already on screen stay put rather than blinking out and back
      if (group.getBoundingClientRect().top < window.innerHeight) {
        group.classList.add('is-revealed');
      } else {
        observer.observe(group);
      }
    });
    document.documentElement.classList.add('ge-reveal');
  }

  function initSlides(root) {
    var slides = root.querySelectorAll('.ge-hero__slide');
    var button = root.querySelector('.ge-hero__pause');
    if (calm || slides.length < 2 || !button || root.hasAttribute('data-ge-ready')) return;
    root.setAttribute('data-ge-ready', '');

    var current = 0;
    var timer = null;
    var paused = false;
    var onScreen = true;

    function advance() {
      var leaving = slides[current];
      leaving.classList.add('is-leaving');
      leaving.classList.remove('is-active');
      setTimeout(function () { leaving.classList.remove('is-leaving'); }, 1400);
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (paused || !onScreen || document.hidden) return;
      timer = setInterval(advance, 6000);
    }

    button.hidden = false;
    button.addEventListener('click', function () {
      paused = !paused;
      button.setAttribute('aria-pressed', paused ? 'true' : 'false');
      root.classList.toggle('is-paused', paused);
      start();
    });

    document.addEventListener('visibilitychange', start);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        start();
      }).observe(root);
    }
    start();
  }

  function initAllSlides() {
    document.querySelectorAll('[data-ge-slides]').forEach(initSlides);
  }

  function init() {
    initReveal();
    initAllSlides();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders a section after each change
  document.addEventListener('shopify:section:load', initAllSlides);
})();
